import api from "../utils/axiosInstance";

const API = "investment";


export const createInvestment = async (data) => {
  try {
    const response = await api.post(`/${API}/create-investment`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const closeInvestment = async (data) => {
  try {
    const response = await api.post(`/${API}/close-investment`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getInvestmentList = async (data) => {
  try {
    const response = await api.post(`/${API}/get-investments-list`, data);
    return response;
  } catch (error) {
    return error;
  }
};

